import React from 'react';
import { useDispatch } from 'react-redux';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import TextInfo, {
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_ALIGN,
  TEXT_INFO_DISPLAY,
} from '@gcloud-npm/next12.components.text-info-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Button from '@gcloud-npm/next12.components.button-m';
import Icon from '@gcloud-npm/next12.components.icon-n';
import styled from 'styled-components';

const COMPONENT_NAME = 'Ver Convocatorias';

const VerConvocatorias = (props) => {
  const dispatch = useDispatch();
  let { taggingInfo } = props;

  if (!taggingInfo) {
    taggingInfo = {
      componentName: COMPONENT_NAME,
      componentProduct: '',
      componentVariation: 'all',
    };
  }

  const closeModal = () => {
    dispatch(modalActions.addModal({ type: 'MODAL', id: '' }));
  };

  const printX = () => {
    return (
      <>
        <span className="closeButton">
          <CustomLink
            taggingInfo={{
              ...taggingInfo,
              componentContent: 'cerrar',
            }}
            onClick={closeModal}
          >
            <Icon id="Cerrar" color="white" kind="M" size={16} segment="emp" />
          </CustomLink>
        </span>
        <style jsx>
          {`
            .closeButton {
              position: absolute;
              top: calc(50% - 0.688rem);
              left: 1.5rem;
            }
          `}
        </style>
      </>
    );
  };

  const printHeader = () => {
    return (
      <>
        <div className="header__wrapper">
          {printX()}
          <TextInfo
            text="Convocatorias"
            align={TEXT_INFO_ALIGN.LEFT}
            size={TEXT_INFO_SIZE.TITLE4}
            color={TEXT_INFO_COLOR.WHITE}
            fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
            kind={TEXT_INFO_KIND.SPAN}
            display={TEXT_INFO_DISPLAY.INLINE}
            className="header_text"
          />
        </div>
        <style jsx>
          {`
            .header__wrapper {
              position: relative;
              text-align: center;
              height: 4rem;
              padding: 0.938rem 1.5rem;
              background-color: var(--color-emp--blue);
            }
          `}
        </style>
      </>
    );
  };

  const printFooter = () => {
    return (
      <>
        <div className="footer__wrapper">
          <Button
            label="Inscríbete ahora"
            buttonType="primary_reverse"
            href="https://thevalleytelefonicaeoi.zohosites.eu/"
            segment="emp"
            target="_blank"
            taggingInfo={{ ...taggingInfo, componentContent: 'interes-modal' }}
          />
        </div>
        <style jsx>
          {`
            .footer__wrapper {
              display: flex;
              position: absolute;
              width: 100%;
              bottom: 0px;
              text-align: center;
              height: 5rem;
              padding: 0.938rem 1.5rem;
              background-color: var(--color-emp--blue);
              justify-content: end;
            }
          `}
        </style>
      </>
    );
  };

  const printConvocatorias = () => {
    return (
      <>
        <div className="wrapper__convocatoria">
          <div className="titulo">
            <TextInfo
              text="Horario de las clases"
              align="left"
              fontType="font-bold"
              size="title06"
              color="grey5"
            />
          </div>
          <ul className="listado">
            <li className="listado--item">
              <TextInfo
                text="En remoto"
                align="left"
                fontType="font-bold"
                size="title06"
                color="grey5"
              />
              <div className="margin-top">
                <TextInfo
                  text="Lunes y miércoles de 18:00 a 21:00 h."
                  align="left"
                  fontType="font-regular"
                  size="title06"
                  color="grey5"
                />
              </div>
            </li>
            <li className="listado--item">
              <TextInfo
                text="Presenciales"
                align="left"
                fontType="font-bold"
                size="title06"
                color="grey5"
              />
              <div className="margin-top">
                <TextInfo
                  text="Viernes alternos de 9:00 a 15:00 h."
                  align="left"
                  fontType="font-regular"
                  size="title06"
                  color="grey5"
                />
              </div>
            </li>
          </ul>
          <br />
          <div className="titulo">
            <TextInfo
              text="Convocatorias abiertas"
              align="left"
              fontType="font-bold"
              size="title06"
              color="grey5"
            />
          </div>
          <ul className="listado">
            <li className="listado--item">
              <TextInfo
                text="17 MAYO 2024"
                align="left"
                fontType="font-bold"
                size="title06"
                color="grey5"
              />
              <div className="margin-top">
                <TextInfo
                  text="Madrid"
                  align="left"
                  fontType="font-regular"
                  size="title06"
                  color="grey5"
                />
              </div>
            </li>
            <li className="listado--item">
              <TextInfo
                text="24 MAYO 2024"
                align="left"
                fontType="font-bold"
                size="title06"
                color="grey5"
              />
              <div className="margin-top">
                <TextInfo
                  text="Barcelona"
                  align="left"
                  fontType="font-regular"
                  size="title06"
                  color="grey5"
                />
              </div>
            </li>
          </ul>
        </div>
        <style jsx>
          {`
            .wrapper__convocatoria {
              overflow: auto !important;
              padding: 2.5rem;
              height: calc(100vh - 9rem);
              ul {
                margin-left: 1.25rem;
              }
              .listado--item {
                padding: 0.9375rem 0;
                list-style: initial;
                color: var(--color-emp--grey5);
                .margin-top {
                  margin-top: 0.5rem;
                }
              }
            }
          `}
        </style>
      </>
    );
  };

  return (
    <>
      <div className="ConvocatoriaModal">
        {printHeader()}
        {printConvocatorias()}
        {printFooter()}
      </div>
      <style jsx>
        {`
          .ConvocatoriaModal {
            height: 100vh;
            width: 100vw;
            background: white;
            overflow: auto;
          }
          @media screen and (min-width: 769px) {
            .ConvocatoriaModal {
              width: 50vw;
              min-width: 43.75rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default VerConvocatorias;
